import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-bpi.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-bpi.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CreateApplicationDetailsBpiConstants } from "./create-application-details-bpi.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { finalize, take, takeUntil } from "rxjs/operators";
import { CreateApplicationLocationBpiConstants } from "../create-application-location-bpi/create-application-location-bpi.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { BuildingPlansInspectorateService } from "../../../../../shared/services/modules/building-plans-inspectorate.service";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
let CreateApplicationDetailsBpiComponent = class CreateApplicationDetailsBpiComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    recipientListService;
    buildingPlansInspectorateService;
    detailsForm;
    showDetails = false;
    captureBpamsReferenceNumber = false;
    detailsFormGroupName = CreateApplicationDetailsBpiConstants.DETAILS_FORM_GROUP_NAME;
    validationMessages = CreateApplicationDetailsBpiConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    verificationMessage = CreateApplicationDetailsBpiConstants.VERIFICATION_MESSAGE;
    bpamsModuleName = "";
    descriptionLabel = CreateApplicationDetailsBpiConstants.DESCRIPTION_LABEL;
    bpamsReferenceNumberLabel = CreateApplicationDetailsBpiConstants.BPAMS_REFERENCE_NUMBER_LABEL;
    hasBpamsReferenceNumberLabel = CreateApplicationDetailsBpiConstants.HAS_BPAMS_REFERENCE_NUMBER_LABEL;
    verifyLabel = CreateApplicationDetailsBpiConstants.VERIFY_LABEL;
    descriptionFormControlName = CreateApplicationDetailsBpiConstants.DESCRIPTION_FORM_CONTROL_NAME;
    bpamsReferenceNumberFormControlName = CreateApplicationDetailsBpiConstants.BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    hasBpamsReferenceNumberFormControlName = CreateApplicationDetailsBpiConstants.HAS_BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    bpamsApplicationIdFormControlName = CreateApplicationDetailsBpiConstants.BPAMS_APPLICATION_ID_FORM_CONTROL_NAME;
    isVerifiedFormControlName = CreateApplicationDetailsBpiConstants.IS_VERIFIED_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsBpiConstants.APPLICATION_TYPE_FROM_CONTROL_NAME;
    applicantFormControlName = CreateApplicationDetailsBpiConstants.APPLICANT_FORM_CONTROL_NAME;
    applicantAgentFormControlName = CreateApplicationDetailsBpiConstants.APPLICANT_AGENT_FORM_CONTROL_NAME;
    markApplicantAgentNaFormControlName = CreateApplicationDetailsBpiConstants.MARK_APPLICANT_AGENT_NA_FORM_CONTROL_NAME;
    propertiesFormControlName = CreateApplicationDetailsBpiConstants.PROPERTIES_FORM_CONTROL_NAME;
    centroidFormControlName = CreateApplicationDetailsBpiConstants.CENTROID_FORM_CONTROL_NAME;
    ownersFormControlName = CreateApplicationDetailsBpiConstants.OWNERS_FORM_CONTROL_NAME;
    applicantFormName = CreateApplicationDetailsBpiConstants.APPLICANT_FORM_NAME;
    propertyFormName = CreateApplicationDetailsBpiConstants.PROPERTY_FORM_NAME;
    isVerified = false;
    missingReferenceNumber = CreateApplicationDetailsBpiConstants.MISSING_REFERENCE_NUMBER;
    yesNoOptions = LookupConstants.YES_NO;
    ownerGroups = [];
    applicantGroups = [];
    applicantAgentGroups = [];
    constructor(createApplicationService, aflaModuleStrategyService, appController, changeDetectorRefs, recipientListService, buildingPlansInspectorateService) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.recipientListService = recipientListService;
        this.buildingPlansInspectorateService = buildingPlansInspectorateService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    setHasBpamsReference(event) {
        const element = event.target?.value;
        if (element !== undefined && element !== null && element !== "") {
            this.showDetails = true;
            if (element.toLowerCase() === "yes") {
                this.updateDisabled(true);
            }
            else {
                this.updateDisabled(false);
            }
        }
        else {
            this.showDetails = false;
        }
        this.changeDetectorRefs.detectChanges();
    }
    updateDisabled(disabled) {
        if (disabled) {
            this.captureBpamsReferenceNumber = true;
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.bpamsReferenceNumberFormControlName).setValidators(Validators.required);
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.isVerifiedFormControlName).setValidators(Validators.required);
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.bpamsApplicationIdFormControlName).setValidators(Validators.required);
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.descriptionFormControlName).disable();
        }
        else {
            this.captureBpamsReferenceNumber = false;
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.bpamsReferenceNumberFormControlName).clearValidators();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.isVerifiedFormControlName).clearValidators();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.bpamsApplicationIdFormControlName).clearValidators();
            this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.descriptionFormControlName).enable();
        }
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName);
        this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.applicationTypeFormControlName).setValue("Building plan inspectorate");
        if (this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.isVerifiedFormControlName).value === true) {
            this.isVerified = true;
            this.showDetails = true;
        }
        else {
            this.isVerified = false;
        }
        const hasBpamsReferenceNumber = this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.hasBpamsReferenceNumberFormControlName).value;
        if (hasBpamsReferenceNumber !== undefined && hasBpamsReferenceNumber !== null && hasBpamsReferenceNumber.toLowerCase() === "yes") {
            this.updateDisabled(true);
            this.showDetails = true;
        }
        if (hasBpamsReferenceNumber !== undefined && hasBpamsReferenceNumber !== null && hasBpamsReferenceNumber.toLowerCase() === "no") {
            this.showDetails = true;
            this.updateDisabled(false);
        }
        else {
            this.updateDisabled(false);
        }
    }
    loadMetadata(stepMeta) {
        this.bpamsModuleName = stepMeta.bpamsModuleName;
        this.ownerGroups = stepMeta.ownerGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
        this.applicantGroups = stepMeta.applicantGroup;
        if (this.applicantGroups[0].hasOwnProperty("requiredFields") && this.applicantGroups[0].requiredFields !== null) {
            this.applicantGroups = this.recipientListService.checkStepMetaRecipientGroups(this.applicantGroups);
        }
        this.applicantAgentGroups = stepMeta.applicantAgentGroup;
        if (this.applicantAgentGroups[0].hasOwnProperty("requiredFields") && this.applicantAgentGroups[0].requiredFields !== null) {
            this.applicantAgentGroups = this.recipientListService.checkStepMetaRecipientGroups(this.applicantAgentGroups);
        }
    }
    onVerifyReferenceNumberClicked() {
        const bpamsReferenceNumber = this.detailsForm.get(this.bpamsReferenceNumberFormControlName).value;
        if (bpamsReferenceNumber != null && bpamsReferenceNumber !== "") {
            const params = {
                bpamsReferenceNumber,
                bpamsModuleName: this.bpamsModuleName,
                moduleId: this.appController.selectedModuleID
            };
            const expand = "properties($expand=owners($expand=groups)),applicant($expand=groups),applicantAgent($expand=groups)";
            this.buildingPlansInspectorateService.verifyReferenceNumberObservable(params, expand).subscribe({
                next: value => {
                    this.populateApplication(value.value[0]);
                    this.appController.showMessage(this.verificationMessage, AlertType.Success);
                    this.isVerified = true;
                    this.changeDetectorRefs.detectChanges();
                },
                error: err => {
                    this.appController.handleServerErrorMessage(CreateApplicationDetailsBpiConstants.name, err, CRUDOperation.Get);
                    this.isVerified = false;
                    this.changeDetectorRefs.detectChanges();
                }
            });
        }
        else {
            this.appController.showMessage(this.missingReferenceNumber, AlertType.Warning);
        }
    }
    populateApplication(application) {
        this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.hasBpamsReferenceNumberFormControlName).disable();
        this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.descriptionFormControlName).setValue(application.description);
        this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.isVerifiedFormControlName).setValue(true);
        this.aflaModuleStrategyService.form.get(this.detailsFormGroupName).get(this.bpamsApplicationIdFormControlName).setValue(application.id);
        if (application.applicant !== undefined && application.applicant !== null && application.applicant.length > 0) {
            this.aflaModuleStrategyService.form.get(this.applicantFormName).get(this.applicantFormControlName).setValue(this.cleanRecipientData(application.applicant[0], this.applicantGroups));
        }
        // set applicantAgent form data
        if (application.applicantAgent !== undefined && application.applicantAgent !== null && application.applicantAgent.length > 0) {
            this.aflaModuleStrategyService.form.get(this.applicantFormName).get(this.applicantAgentFormControlName).setValue(this.cleanRecipientData(application.applicantAgent[0], this.applicantAgentGroups));
            this.aflaModuleStrategyService.form.get(this.applicantFormName).get(this.markApplicantAgentNaFormControlName).setValue(true);
        }
        else {
            this.aflaModuleStrategyService.form.get(this.applicantFormName).get(this.markApplicantAgentNaFormControlName).setValue(false);
            this.aflaModuleStrategyService.form.get(this.applicantFormName).get(this.applicantAgentFormControlName).disable();
            this.aflaModuleStrategyService.form.get(this.applicantFormName).get(this.applicantAgentFormControlName).reset();
        }
        const applicantForm = this.aflaModuleStrategyService.form.get(this.applicantFormName);
        applicantForm.clearValidators();
        const propertyControl = this.aflaModuleStrategyService.form.get(this.propertyFormName).get(this.propertiesFormControlName);
        propertyControl.clear();
        application.properties.forEach(property => {
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
            const geom = JsonUtils.fromJSON(geometryArc);
            const newProperty = new FormGroup({
                property: new FormControl(property),
                erfNo: new FormControl(property.erfNumber, [Validators.required]),
                subdivision: new FormControl(property.subdivision, [Validators.required]),
                allotment: new FormControl(property.allotment, [Validators.required]),
                farmNo: new FormControl(property.farmNumber, [Validators.required]),
                sgCode: new FormControl(property.sgCode, [Validators.required]),
                address: new FormControl(property.address, [Validators.required]),
                erfSize: new FormControl(property.erfSize, [Validators.required]),
                titleDeed: new FormControl(property.titleDeed, [Validators.required]),
                geometry: new FormControl(geom),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl({ recipients: [] }, [Validators.required])
            });
            newProperty.controls.sgCode.disable();
            newProperty.controls.erfNo.disable();
            newProperty.controls.farmNo.disable();
            newProperty.controls.subdivision.disable();
            newProperty.controls.allotment.disable();
            newProperty.controls.address.disable();
            newProperty.controls.titleDeed.disable();
            newProperty.controls.erfSize.disable();
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometryArc));
            const getTrueCentroid = this.createApplicationService.getTrueCentroid(url, formData).pipe(takeUntil(this._destroy$), take(1)).pipe(finalize(() => {
                getTrueCentroid.unsubscribe();
            })).subscribe({
                next: (response) => {
                    newProperty.get(this.centroidFormControlName).setValue(response.results[0].value);
                    propertyControl.push(newProperty);
                    this.changeDetectorRefs.detectChanges();
                    const ownersControl = newProperty.get(this.ownersFormControlName);
                    const owners = [];
                    property.owners.forEach(owner => {
                        if (owner !== undefined && owner !== null) {
                            owners.push(this.cleanRecipientData(owner, this.ownerGroups));
                        }
                    });
                    this.recipientListService.setRecipients(owners, false, ownersControl);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(CreateApplicationLocationBpiConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        });
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    cleanRecipientData(recipient, newGroups) {
        const clean = {};
        clean.clientVatNumber = recipient.clientVatNumber;
        clean.fullName = recipient.fullName;
        clean.id = 0;
        clean.moduleId = recipient.moduleId;
        clean.name = recipient.name;
        clean.surname = recipient.surname;
        clean.telephone = recipient.telephone;
        clean.email = recipient.email;
        clean.defaultCommunicationMethod = recipient.defaultCommunicationMethod;
        clean.postalAddress = recipient.postalAddress;
        clean.designation = recipient.designation;
        clean.organisation = recipient.organisation;
        clean.streetAddress = recipient.streetAddress;
        clean.homePhone = recipient.homePhone;
        clean.idNumber = recipient.idNumber;
        clean.organisationRegistrationNumber = recipient.organisationRegistrationNumber;
        clean.representative = recipient.representative;
        clean.fax = recipient.fax;
        clean.maritalStatus = recipient.maritalStatus;
        clean.relativesFullName = recipient.relativesFullName;
        clean.relativesContactNumber = recipient.relativesContactNumber;
        clean.relativesAddress = recipient.relativesAddress;
        clean.employmentStatus = recipient.employmentStatus;
        clean.employersName = recipient.employersName;
        clean.employersContactNumber = recipient.employersContactNumber;
        clean.employersAddress = recipient.employersAddress;
        clean.cellphone = recipient.cellphone;
        clean.streetSuburb = recipient.streetSuburb;
        clean.streetCity = recipient.streetCity;
        clean.streetProvince = recipient.streetProvince;
        clean.streetCode = recipient.streetCode;
        clean.postalSuburb = recipient.postalSuburb;
        clean.postalCity = recipient.postalCity;
        clean.postalProvince = recipient.postalProvince;
        clean.postalCode = recipient.postalCode;
        clean.postalCountry = recipient.postalCountry;
        clean.streetCountry = recipient.streetCountry;
        clean.professionalBody = recipient.professionalBody;
        clean.professionalBodyRegNum = recipient.professionalBodyRegNum;
        clean.consolidatedGroup = recipient.consolidatedGroup;
        clean.emailField = recipient.emailField;
        let groups = {};
        groups = [];
        newGroups.forEach(g => {
            const group = {};
            // @ts-ignore
            group.groupName = g.GroupName;
            // @ts-ignore
            group.groupType = g.GroupType;
            groups.push(group);
        });
        clean.groups = groups;
        /*      owner.groupsStringArray?: string[]; */
        return clean;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RecipientListService },
        { type: BuildingPlansInspectorateService }
    ];
};
CreateApplicationDetailsBpiComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-bpi",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsBpiComponent);
export { CreateApplicationDetailsBpiComponent };
